import React from 'react'
import { Container, Row, Col, Image,  Table } from "react-bootstrap";
import {
    LinkToUsTableSection,
    LinkToUsTableTitle,
    ContactButton,
    Thead,
    ImageSize,
    ImageSizeStrong,
    Tbody,
    DownloadButton,
    DownloadLinkButton,
    ImageShow,
    TableHtmlCode,
    TableHtmlCodeBox,
    TableHtmlCodeHeading,
    TableHtmlCodeTitle,
    CodeCopyButton,
    TableHtmlCodeWrap,
    TableMain,
    TableRow,
    TableHead,
    TableDiv,
 } from './LinkToUsTableSectionStyle';

const MarqueeWrapper = ({listingData}:any) => {

  const handleCopy = (text:any) => {
    navigator.clipboard.writeText(text).then(() => {
        
    }).catch(err => {
        console.error('Failed to copy text: ', err);
    });
};

  return (
      <LinkToUsTableSection>
        <Container className="cont-w">
            <Row>
              <Col sm="12">
              <LinkToUsTableTitle>
                  Copy the HTML code or click on the download button listed on the right column in the table below to automatically download a .png for you to use on your website, blog or other marketing materials. If you need a different size or format, please
                  <ContactButton href="#" className="contact-now-btn">
                    contact us
                  </ContactButton>
                  .
              </LinkToUsTableTitle>
              </Col>
            </Row>
            <Row>
              <Col sm="12">
              <TableMain>
                  <Table className="link-to-us-table" variant="white"  size="sm" responsive hover>
                    <Thead>
                        <TableRow>
                          <TableHead>Image Size</TableHead>
                          <TableHead>Logos</TableHead>
                          <TableHead>Download Links</TableHead> 
                          <TableHead>HTML Code</TableHead>
                        </TableRow>
                    </Thead>
                    <Tbody>
                        {listingData?.map((listing:any, index:number) => (
                          <TableRow className="table-row-data" key={index+1}>
                          <TableDiv>
                              <ImageSize><ImageSizeStrong>Large</ImageSizeStrong>{listing?.large_image_size}</ImageSize>
                              <ImageSize><ImageSizeStrong>Small</ImageSizeStrong>{listing?.small_image_size}</ImageSize>
                          </TableDiv>
                          <TableDiv>
                              <ImageShow>
                                <Image src={listing?.image} alt="link-to-us-nonprofit"/>
                              </ImageShow>
                          </TableDiv>
                          <TableDiv>
                              <DownloadButton>
                                <DownloadLinkButton className="download-link-large-btn">Download (Large)</DownloadLinkButton>
                                <DownloadLinkButton className="download-link-small-btn">Download (Small)</DownloadLinkButton>
                              </DownloadButton>
                          </TableDiv>
                          <TableDiv>
                              <TableHtmlCode>
                                <TableHtmlCodeBox>
                                    <TableHtmlCodeHeading>
                                      <TableHtmlCodeTitle>Large</TableHtmlCodeTitle>
                                      <CodeCopyButton className="CodeCopy-large-btn" onClick={() => handleCopy(listing?.large_html_code)}>Copy to Clipboard</CodeCopyButton>
                                    </TableHtmlCodeHeading>
                                    <TableHtmlCodeWrap>{listing?.large_html_code}</TableHtmlCodeWrap>
                                </TableHtmlCodeBox>
                                <TableHtmlCodeBox>
                                    <TableHtmlCodeHeading>
                                      <TableHtmlCodeTitle>Small</TableHtmlCodeTitle>
                                      <CodeCopyButton className="CodeCopy-large-btn" onClick={() => handleCopy(listing?.small_html_code)}>Copy to Clipboard</CodeCopyButton>
                                    </TableHtmlCodeHeading>
                                    <TableHtmlCodeWrap>{listing?.small_html_code}</TableHtmlCodeWrap>
                                </TableHtmlCodeBox>
                              </TableHtmlCode>
                          </TableDiv>
                        </TableRow>))}
                    </Tbody>
                  </Table>
              </TableMain>
              </Col>
            </Row>
        </Container>
      </LinkToUsTableSection>
  )
}

export default MarqueeWrapper
